import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20turquoise%20ocean%20waves%20digital%20technology%20flowing%20water%20light%20refraction%20glass%20crystal%20transparent%20aqua%20blue%20teal%20gradient%20modern%20IT%20software%20development%20background%20with%20geometric%20shapes%20and%20glowing%20particles%20in%20deep%20ocean%20colors&width=1920&height=1080&seq=ocean-hero-01&orientation=landscape"
          alt="Ocean hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-teal-900/60 via-teal-800/50 to-teal-900/70"></div>
      </div>

      {/* Floating wave decoration */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none">
        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="white" fillOpacity="1"/>
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 md:px-8 max-w-5xl mx-auto">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 mb-6">
          <div className="w-2 h-2 rounded-full bg-teal-300 animate-pulse"></div>
          <span className="text-white/90 text-xs font-medium tracking-wider uppercase">IT Solutions for Your Business</span>
        </div>

        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          テクノロジーで、<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-200 to-cyan-300">
            未来を切り拓く
          </span>
        </h1>

        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          システム開発・アプリ開発・Webサービス運営まで。<br className="hidden md:block" />
          株式会社Oceanが、あなたのビジネスをデジタルで加速させます。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="px-8 py-3 rounded-full bg-gradient-to-r from-teal-400 to-cyan-500 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
          >
            無料相談はこちら
          </Link>
          <Link
            to="/services"
            className="px-8 py-3 rounded-full border border-white/40 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-white/10 transition-colors backdrop-blur-sm"
          >
            サービスを見る
          </Link>
        </div>

        {/* Stats */}
        <div className="mt-14 grid grid-cols-3 gap-4 max-w-lg mx-auto">
          {[
            { value: '2023', label: '設立' },
            { value: '3+', label: 'サービス領域' },
            { value: '24h', label: 'サポート対応' },
          ].map((stat) => (
            <div key={stat.label} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-3">
              <div className="text-2xl font-bold text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {stat.value}
              </div>
              <div className="text-white/60 text-xs mt-0.5">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
